import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { toast } from "react-toastify"

import Layout from "../../layouts/layout"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"
import { useForm } from "react-hook-form"
import { DatePicker, DateTimePicker } from "react-advance-jalaali-datepicker"
import { useRequestProcessor } from "../../api/requestProcessor"
import { getSingleDiscount, updateSingleDiscounts } from "../../api/discounts"
import { getAllWorkshops, getAllWorkshopsWithoutPaginate } from "../../api/workshops"
import { getAllUsers, getAllUsersWithoutPaginate } from "../../api/users"


import Select from "react-select";
import makeAnimated from 'react-select/animated';
import { getAllCoursesWithoutPaginate } from "../../api/course"

const EditDiscount = () => {

    const [isCheck, setIsCheck] = useState(false);
    const [isActive, setIsActive] = useState(false)
    const [expireDate, setExpireDate] = useState(null)
    const [selectedUsers, setSelectedUsers] = useState()
    const [selectedWorkshop, setSelectedWorkshop] = useState()
    const [selectedCourses, setSelectedCourses] = useState()


    const { register, handleSubmit, formState: { errors }, reset } = useForm();

    const { discount_id } = useParams()

    const { Query, Mutate } = useRequestProcessor();
    const navigate = useNavigate();

    const { data: workshopData, } = Query(
        ['getAllWorkshopsWithoutPaginate'],
        () => getAllWorkshopsWithoutPaginate(),
    );
    const { data: usersData, } = Query(
        ['getAllUsersWithoutPaginate'],
        () => getAllUsersWithoutPaginate(),
    );
    const { data: courseData, } = Query(
        ['getAllCoursesWithoutPaginate'],
        () => getAllCoursesWithoutPaginate(),
    );

    const { mutate } = Mutate(["updateSingleDiscount",discount_id],
        updateSingleDiscounts,
        {
            onSuccess: (data) => {
                console.log(data);
                toast.success(data.message)
                toast.info("تا چند ثانیه دیگر به صفحه اصلی منتقل میشوید", {
                    autoClose: 2500,
                    pauseOnHover: false
                })
                setTimeout(() => { navigate("/admin/discounts") }, 3000)
            },
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    )

    const { data, isLoading, refetch } = Query(
        ['getSingleDiscount',],
        () => getSingleDiscount(discount_id),
    );

    function change(unix, formatted) {
        setExpireDate(unix);
    }

    useEffect(() => {
        reset(data?.data)
        setIsActive(data?.data?.active)
        setIsCheck(!!data?.data?.percent)
        setExpireDate(data?.data?.expire_date)
        setSelectedUsers(data?.data?.discount_user?.map(el => ({ label: el.user.name + " " + el.user.lastname, value: el.user.id })))
        setSelectedWorkshop(data?.data?.discount_item.map(el => el.type === "workshop" && ({ label: el.title, value: el.type_id })  ))
        setSelectedCourses(data?.data?.discount_item.map(el => el.type === "course" && ({ label: el.title, value: el.type_id })))
    }, [data])

    function onSubmitHandler(data) {
        const { percent, ...restData } = data;
        mutate({ id :discount_id ,data:{
            ...restData, percent: percent ?? null, expire_date: expireDate ?? null, active: isActive,
            users_id: selectedUsers ? selectedUsers?.map(el => el.value) : null,
            workshop_id: selectedWorkshop ? selectedWorkshop?.map(el => el.value) : null,
            course_id: selectedCourses ? selectedCourses?.map(el => el.value) : null
        }
        })
    }



const animatedComponents = makeAnimated();
function handleOnChange(data) {
    setSelectedUsers(data)
}
function handleOnChangeWorkshop(data) {
    setSelectedWorkshop(data)
}
function handleOnChangeCourses(data) {
    setSelectedCourses(data)
}

return (
    <Layout >
        <MainPageLayout backButton sectionTitle={"تصحیح تخفیف :"} title={"تصحیح تخفیف "} >
            <form onSubmit={handleSubmit(data => onSubmitHandler(data))}>
                <div className='flex flex-col my-4'>
                    <div className="flex wsm:flex-col">
                        <div className="flex flex-col w-full justify-between">
                            <div className='flex flex-col my-3'>
                                {<p className={` ${errors.code && errors.code.type === "required" ? "text-red-500 " : ""}pr-3 pb-1`}>کد تخفیف : {errors.percent && errors.percent.type === "maxLength" && "*"}</p>}
                                <input type="text" {...register("code", { required: true })} className='form-input !w-full' placeholder='کد تخفیف ' />
                            </div>
                            <div className='flex flex-col my-3'>
                                {<p className={` ${errors.use_limit && errors.use_limit.type === "required" ? "text-red-500 " : ""}pr-3 pb-1`}>حد استفاده : {errors.percent && errors.percent.type === "maxLength" && "*"}</p>}
                                <input type="number" {...register("use_limit")} className='form-input !w-full' placeholder='حد استفاده' />
                            </div>
                        </div>
                        <div className="flex flex-col w-full mr-3 wsm:!mr-0">
                            <div className='flex flex-col my-3'>
                                {<p className={` ${errors.type && errors.type.type === "required" ? "text-red-500 " : ""}pr-3 pb-1`}>نوع تخفیف : {errors.percent && errors.percent.type === "maxLength" && "*"}</p>}
                                <select {...register("type", { required: true })} className="w-full mt-2 border border-gray-500 py-[10px] px-[20px] rounded-[10px] focus:border-[#1976d2bf]" >
                                    <option selected disabled hidden value={""}>انتخاب نوع تخفیف</option>
                                    <option className="py-3" value={"public"} >عمومی (public)</option>
                                    <option value={"private"} >خصوصی (private)</option>
                                </select>
                            </div>
                            <div className="flex flex-col my-3">
                                <p className={`pr-3 pb-1 `}>انتخاب تاریخ انقضا :</p>
                                <DateTimePicker format="jYYYY/jMM/jDD HH:mm" onChange={change}  containerClass="form-input date-picker-bg wsm:!w-fit"
                                    cancelOnBackgroundClick customClass="cs" placeholder={ expireDate ?  new Date(expireDate * 1000).toLocaleString('fa-IR') : "تاریخ را انتخاب کنید  "} className='form-input w-full' />
                            </div>

                        </div>
                    </div>
                    <div className="flex-col py-3">
                        <div class="flex-col  w-full ">
                            <p>نوع تخفیف :</p>
                            <div className="mx-10 wsm:!mx-0 items-center flex mt-2">
                                <p>درصدی</p>
                                <label class="relative inline-flex  cursor-pointer mx-2">
                                    <input type="checkbox" checked={isCheck} onChange={(e) => setIsCheck(prev => !prev)} class="sr-only peer" />
                                    <div class={`w-11 h-6  rounded-full peer bg-sky-300 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all `}></div>
                                </label>
                                <p>نقدی</p>
                            </div>
                        </div>
                        <div className='flex flex-col my-3'>
                            {
                                isCheck ?
                                    <>
                                        {<p className={` ${errors.percent && errors.percent.type === "maxLength" ? "text-red-500 " : ""}pr-3 pb-1`}>درصد تخفیف : {errors.percent && errors.percent.type === "maxLength" && "*"}</p>}
                                        <input type="number" {...register("percent", { required: true, maxLength: 2 })} className='form-input w-full wsm:!w-full' placeholder='درصد تخفیف (10%)' />
                                    </>
                                    :
                                    <>
                                        {<p className={` ${errors.amount && errors.amount.type === "required" ? "text-red-500 " : ""}pr-3 pb-1`}>قیمت تخفیف : {errors.percent && errors.percent.type === "maxLength" && "*"}</p>}
                                        <input type="number" {...register("amount", { required: true })} className='form-input w-full wsm:!w-full' placeholder='قیمت تخفیف ( به تومان )' />
                                    </>
                            }
                        </div>
                    </div>
                    <div class="flex-col  w-full ">
                        <p>وضعیت تخفیف :</p>
                        <div className="mx-10 items-center flex wsm:!mx-0 mt-2">
                            <p>فعال</p>
                            <label class="relative inline-flex  cursor-pointer mx-2">
                                <input type="checkbox" checked={isActive} onChange={(e) => setIsActive(prev => !prev)} class="sr-only peer" />
                                <div class={`w-11 h-6  rounded-full peer ${isActive ? "bg-sky-300" : "bg-gray-200"}  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all `}></div>
                            </label>
                            <p>غیر فعال</p>
                        </div>
                    </div>
                </div>
                <div className="flex">
                    <div className="w-full">
                        <div className='flex flex-col '>
                            <p className='pr-3 pb-1'>انتخاب کاربران :</p>
                            <Select components={animatedComponents} placeholder="انتخاب کنید..."
                                onChange={handleOnChange} closeMenuOnSelect={false} value={selectedUsers}
                                isMulti options={usersData?.data?.map(el => ({ label: el.name + " " + el.lastname, value: el.id }))}
                            />
                        </div>
                    </div>

                    <div className="w-full pr-4">
                        <div className='flex flex-col mr-3'>
                            <p className='pr-3 pb-1'>انتخاب ورک شاپ :</p>
                            <Select components={animatedComponents} placeholder="انتخاب کنید..." styles={{ zIndex: "-1" }}
                                onChange={handleOnChangeWorkshop} closeMenuOnSelect={false} value={selectedWorkshop} isMulti
                                options={workshopData?.data?.map(el => ({ label: el.title, value: el.id }))}
                            />
                        </div>

                        <div className='flex flex-col mt-4 mr-3'>
                                <p className='pr-3 pb-1'>انتخاب دوره :</p>
                                <Select components={animatedComponents} placeholder="انتخاب کنید..." styles={{ zIndex: "-1" }}
                                    onChange={handleOnChangeCourses} closeMenuOnSelect={false} value={selectedCourses} isMulti 
                                    options={courseData?.data?.map(el => ({ label: el.title, value: el.id }))}
                                />
                            </div>
                    </div>

                </div>
                <div id='form-add-button--container'>
                    <button type="submit" id='form-add-button'>ثبت</button>
                </div>
            </form>
        </MainPageLayout>
    </Layout>
)
}

export default EditDiscount